module.exports = __webpack_public_path__ + "static/recognize-activity-3-9b2b01ef872ae0423c42eb213f995404.mp4";